import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'ac-type-7-icon',
  templateUrl: './ac-type-7-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AcType7IconComponent {}
